
import React from 'react';

export const TeamSection: React.FC = () => {
  const teamMembers = [
    {
      name: 'Sarah Johnson',
      position: 'Founder & CEO',
      image: '/teams/sarah-johnson.jpg',
      description: 'With over 15 years in the travel industry, Sarah founded Prime Meridian Travel with a vision to create meaningful travel experiences.'
    },
    {
      name: 'Michael Chen',
      position: 'Head of Operations',
      image: '/teams/michael-chen.jpg',
      description: 'Michael ensures every travel itinerary runs smoothly, bringing 12 years of operational excellence to our team.'
    },
    {
      name: 'Emma Rodriguez',
      position: 'Senior Travel Consultant',
      image: '/teams/emma-rodriguez.jpg',
      description: 'Emma specializes in luxury and adventure travel, helping clients discover unique destinations around the world.'
    },
    {
      name: 'David Thompson',
      position: 'Cruise Specialist',
      image: '/teams/david-thompson.jpg',
      description: 'David is our cruise expert with extensive knowledge of all major cruise lines and exclusive access to special deals.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Meet Our Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our experienced travel professionals are passionate about creating extraordinary journeys for every client
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-48 h-48 rounded-full object-cover object-top mx-auto shadow-lg group-hover:shadow-xl transition-shadow duration-300"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
              <p className="text-emerald-600 font-semibold mb-3">{member.position}</p>
              <p className="text-gray-600 text-sm leading-relaxed">{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
